<template>
	<v-container>
		<v-card class="shadowCard">
			<v-card-title primary-title>
			  <span class="text-caption">Contraseña</span>
			</v-card-title>
			<v-card-text>
				<v-form
			    ref="form"
			    v-model="contrasenias"
			    lazy-validation
			  >
			  	<v-row>
			  		<v-col cols="12" class="pb-0">
					    <v-text-field
		            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
		            :rules="rules"
		            :type="showPassword ? 'text' : 'password'"
		            name="input-10-2"
		            label="Contraseña actual"
		            v-model="nuevoPass"
		            @click:append="showPassword = !showPassword"
		            rounded
		            filled
		            color="primary"
		            hide-details
		            :disabled="disabled"
		          ></v-text-field>
			  		</v-col>

			  		<v-col cols="12" class="pb-0">
					    <v-text-field
		            :append-icon="showPassword2 ? 'mdi-eye' : 'mdi-eye-off'"
		            :rules="rules"
		            :type="showPassword2 ? 'text' : 'password'"
		            name="input-10-2"
		            label="Nueva contraseña"
		            v-model="nuevoPass2"
		            @click:append="showPassword2 = !showPassword2"
		            rounded
		            filled
		            color="primary"
		            hide-details
		            :disabled="disabled"
		          ></v-text-field>
						</v-col>
			  	</v-row>
			  </v-form>
			</v-card-text>

		  <v-card-actions class="mt-4">
		    <v-spacer></v-spacer>
		    <v-btn
		    	v-if="modoVista == 1"
		      color="primary"
		      class="text-capitalize px-6"
		      @click="disabled = false, modoVista = 2"
		      rounded
		    >
		      Cambiar contraseña
		    </v-btn>

		    <v-btn
		    	v-else
		      color="primary"
		      class="text-capitalize px-6"
		      @click="validarPassword()"
		      rounded
		    >
		      Guardar
		    </v-btn>
		  </v-card-actions>
		</v-card>

		<Alerta    v-if="respuestaAlerta" :parametros="parametros"/>
	  <Loader    v-if="cargar"          :loader="loader"/>

	</v-container>
</template>
<script>
	import { mapActions, mapGetters } from 'vuex'
	// Dependencias
  const md5     = require('md5')

  // Componentes
  import Alerta     from '@/components/alertas/Alerta.vue'
  import Loader     from '@/components/alertas/Loader.vue'

  export default {
  	components:{
  		Alerta,
  		Loader
  	},

    data: () => ({
    	modoVista: 1, // 1-. Editar, 2-. Guardar
    	disabled: true,
      contrasenias: true,
    	
    	// Datos del usuario
    	nuevoPass:'',
    	nuevoPass2:'',

      showPassword: false,
      showPassword2: false,
      rules: [
        v => !!v || 'Requerido',
        v => (v && v.length >= 7 ) || 'Debes ingresar más de 8 caractéres',
      ],

      respuestaAlerta: false,
      success:false,

      loader: true,
      cargar: false,
			parametros:{
      	dialogError: false,
      	mensaje: '',
      	color: ''
     	},
    }),

    computed:{
    	...mapGetters( 'login', [ 'getUsuarioLMS', 'getDatosUsuarioLMS']),

    },

    methods: {
    	...mapActions( 'login', [ 'grabarUsuario', 'grabarDatosUsuario' ]),

      validarDatos () {
        return this.$refs.form.validate()
      },

      validarPassword (){
      	this.cargar = true
      	if( this.validarDatos() ){
      		// validar los datos del usuario
      		const payload = {
	      		id: this.getUsuarioLMS.id,
	      		password: this.nuevoPass,
	      		newpassword: this.nuevoPass2
	      	}

	      	this.$http.post('usuario.update.password', payload).then( response => {
	      		this.cargar                    = false
	      		this.parametros.mensaje        = response.body.message
      			this.parametros.dialogError    = true 
      			this.parametros.color          = 'success'
      			this.respuestaAlerta           = true  
      			this.disabled                  = true
      			this.modoVista                 = 1
      			this.nuevoPass2                = ''
      			this.nuevoPass                 = ''
	      	}).catch( error => {
	      		this.cargar = false
	      		if( error.status == 400 || error.status == 500){
	      			this.parametros.mensaje      = error.body.message
	      			this.parametros.dialogError  = true 
	      			this.parametros.color        = '#FF2C2C' 
	      			this.respuestaAlerta         = true 
	      		}
	      	}).finally( () => { this.cargar = false })
      	}
      },
    },
  }
</script>
<style scoped>
	.shadowCard{
		border-radius: 15px !important; 
		box-shadow: 0 20px 27px 0 rgba(0,0,0,0.15)  !important;
	}

</style>